// Styles here will override Bulma styles
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import media from 'css-in-js-media';

export const styledSection = css`
  padding-top: 32px;
  padding-bottom: 32px;
`;

export const StyledHeadingContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  max-width: 870px;
  margin: 0 auto 16px auto;
  margin-top: -115px;
  padding-top: 115px;
`;

export const styledHeading = css`
  margin: 0 8px 0 0;
`;

export const StyledParagraph = styled.div`
  p {
    color: ${props => props.subheadingColor || '#5b6987'};
  }

  a {
    font-size: 16px;
    line-height: 160%;
    font-weight: normal;
    font-style: normal;
    font-family: 'WorkSans-Regular';
    color: #0069ff;

    :hover {
      color: #1633ff !important;
    }
  }
`;

export const StyledToolTip = styled.div`
  position: relative;
  display: inline-block;

  :hover span {
    visibility: visible;
    opacity: 1;
  }
  ${media('<tablet')} {
    display: none;
  }
`;
export const StyledToolTipText = styled.span`
  visibility: hidden;
  width: 300px;
  background-color: #031b4e;
  color: #fff;
  text-align: left;
  padding: 10px;
  border-radius: 6px;
  font-size: 12px;

  /* Position the tooltip text */
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -60px;

  /* Fade in tooltip */
  opacity: 0;
  transition: opacity 0.3s;

  ::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 18%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #031b4e transparent transparent transparent;
  }
`;

export const styledTable = css`
  max-width: 870px;
  margin: 0 auto;
  border-spacing: 0px;
  border-collapse: collapse;
  empty-cells: show;
  font-size: 14px;
  table-layout: fixed;
  margin-bottom: 40px;
  margin-top: 24px;
  -ms-overflow-style: none !important;

  &::-webkit-scrollbar {
    display: none !important;
  }

  ${media('<tablet')} {
    overflow: scroll;
    display: inline-block;
  }

  a {
    cursor: pointer;
    color: #0069ff;

    :hover {
      color: #1633ff !important;
    }
  }

  thead,
  tbody {
    td {
      color: #5b6987;
      background: #fff !important;
      border-bottom: 1px solid #e5e8ed;
      padding: 10px 0;
      vertical-align: middle;

      ${media('<tablet')} {
        min-width: 120px;
      }
    }
    th {
      padding: 10px 0;
      color: #031b4e !important;
      border-bottom: 2px solid #e5e8ed;
      font-family: 'WorkSans-Bold';
      font-weight: normal;
    }
    td:last-child,
    th:last-child {
      width: 55px;
      padding-right: 0;
    }
  }

  tr:hover td {
    background-color: #f2f8ff !important;
  }
`;

export const styledLink = css`
  font-family: 'WorkSans-Regular';
  font-weight: normal;
`;

export const StyledPopularPill = styled.span`
  background: #15cd72;
  color: #fff;
  font-size: 12px;
  padding: 3px 6px;
  border-radius: 100px;
  margin-left: 15px;
`;

export const StyledSmallText = styled.div`
  font-size: 14px;
  color: #5b6987;
  margin: 30px 0;

  span {
    font-weight: 900;
  }
`;

export const StyledManagedDatabase = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;

  .complexity-paragraph {
    margin-top: 32px;
    a {
      font-family: 'WorkSans-Regular';
      color: #0069ff;
      :hover {
        color: #1633ff !important;
      }
    }
  }

  .dropletsPricingBox {
    width: 100%;
    margin-top: 24px;

    ul {
     list-style: none;
     padding: 0;
    }

    ul.priceBox {
       display: flex;
       justify-content: space-between;

       @media (max-width: 1219px) {
        flex-direction: column;
      }

       li {
        padding: 5px 0;
        min-width: 111px;
       }

       li.priceBoxItem {
        padding: 0;
        border: 1px solid #e5e8ed;
        border-radius: 4px;
      }
    }
  }

  .databaseTabs {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 8px 0px 0px;

    ul {
      list-style: none;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;


      ${media('<tablet')} {
        flex-direction: row;
        width: auto;
        justify-content: space-between;
      }

      li {
          cursor: pointer;
          width: 217px;
          height: 48px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-bottom: 2px solid #E5E8ED;

          &.active {
            background: #E6EEFF;
            border-bottom: 2px solid #0069FF;
          }

          a {
          font-family: 'WorkSans-Regular', Arial, Helvetica, sans-serif;
          display: flex;
          flex-direction: column;

          span {
            font-size: 12px;
            line-height: 16px;
          }
      }

      .new {
          color: white;
          background-color:rgb(0,105,255);
          font-size: 11px;
          text-transform: uppercase;
          font-family: 'WorkSans-Bold',  Arial, Helvetica, sans-serif;
          padding: 2px 8px;
          border-radius: 4px;
          line-height: 20px;
          margin: 0 10px;
          }
      a {
        color: #031B4E;
      }
      a.active {
          color: rgb(0,105,255);
      }
      }
    }
  }

  .dropletsTabsContainer {
    .dropletsTabs {
      display: flex;
      align-items: center;
      margin-top: 26px;
      overflow: scroll;
      flex-wrap: wrap;

      label {
         display: flex;
         align-items: center;
         cursor: pointer;

         div {
            display: flex;
            flex-direction: column;
         }
      }

      input {
         width: 18px;
         height: 18px;
         margin-right: 16px;
      }

      p {
         font-family: 'WorkSans-Medium',  Arial, Helvetica, sans-serif;
      }

      ul {
         list-style: none;
         display: flex;
         justify-content: left;
         flex-wrap: wrap;

         li {
            display: flex;
            justify-content: center;
            align-items: center;

            a {
            font-family: 'WorkSans-Regular', Arial, Helvetica, sans-serif;
            display: flex;
            flex-direction: column;
            margin: 0 10px 0 40px;


            span {
               font-size: 12px;
               line-height: 16px;
            }
         }

         .new {
            color: white;
            background-color:rgb(0,105,255);
            font-size: 11px;
            text-transform: uppercase;
            font-family: 'WorkSans-Bold',  Arial, Helvetica, sans-serif;
            padding: 2px 8px;
            border-radius: 4px;
            line-height: 20px;
            margin: 0 10px;
            }

         a.active {
            color: rgb(0,105,255);
         }
      }
    }
  }

`;
